import { downloadFile, Station } from '@mi-front/core';
import { apiClient } from '../../../api';

// This file previously contained Redux thunk actions that have been migrated to hooks.
// See: apps/app/src/modules/audit/hooks/useAuditPlayback.ts

export function auditDownloadAudio(p: { stationId: string; customId: string }) {
  downloadFile(
    apiClient.audit.getDownloadAudioUrl({
      ...p,
      download: true,
    }),
  );
}

export function downloadAuditResults({ station, month }: { station: Station; month: string }) {
  return () => {
    const downloadUrl = `${apiClient.getApiRoot()}/stations/${
      station.slug
    }/audit/results?month=${month}&download=1&access_token=${apiClient.getToken()}`;
    window.open(downloadUrl);
  };
}
